export const COUPON_STATUS = {
  AVAILABLE: "AVAILABLE",
  ACTIVATED: "ACTIVATED",
  REDEEMED: "REDEEMED",
  INACTIVE: "INACTIVE",
};
